import { Project } from '..';
import { Configs } from '../../configs';
import { SessionManager } from '../../tracking';

export class ProjectsRepository {
  constructor(private readonly config: Configs, private readonly sessionManager: SessionManager) {}
  async getClientProjectByEnvironmentId(id: string): Promise<Project> {
    const userBase64 = this.sessionManager.getBase64User();

    const path = `workflows/${id}/${userBase64}`;
    //const path = `/client-project/${id}`;
    if (!id) {
      throw Error('id is required');
    }

    const url = `${this.config.samelogicApiBaseUrl}/${path}`;
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors'
    });

    if (!response.ok) {
      throw new Error(`ERROR: could not load project from ${url}`);
    }

    return (await response.json()) as Project;
  }
}
